import dyslexiaCutlines from '../../../../dummy_data/reports/dyslexiaCutlines';

export function generateDyslexiaReport(scores, benchmark, selectedLocale) {
  let cutlines = benchmark.grade > dyslexiaCutlines.length-1 ? dyslexiaCutlines[dyslexiaCutlines.length-1] : dyslexiaCutlines[benchmark.grade];

  // label scores based on cutline
  scores.map(scoreData => {
    if([scoreData.status,scoreData.displayStatus].includes('underReview')){
      scoreData.labeledScore = 'Under Review';
      scoreData.score = null;
    }

    return scoreData;
  });

  return {
    selectedLocale,
    scores,
    cutlines,
    cutoffs: { // note: if we ever decide to add additional dyslexia cutlines, reconsider this
      HIGH_RISK: cutlines[1].value,
      MEDIUM_RISK: cutlines[0].value,
    },
  };
}

export default {
  generateDyslexiaReport,
}